module.exports = require('../../lib/templates/gametemplate-src/index');